























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class FurnitureTableHeader extends Vue {
  @Prop({ default: "Default title" })
  readonly title!: string;

  @Prop({ default: "" })
  readonly subtitle!: string;

  @Prop({})
  readonly value!: string;

  updateSearch(value: string): void {
    this.$emit("input", value);
  }
}
